export const FONTS = Object.freeze({
  'Noto Sans': 'noto-sans',
  Pretendard: 'pretendard',
  나눔명조: 'nanum-gothic',
  '나눔손글씨 손편지체': 'nanum-myeongjo',
});

export const TEXT_FORMAT = [
  'font',
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'align',
  'color',
  'background',
  'size',
  'h1',
];
